export const OBJETIVOS_OPTIMIZACION = [
  {
    name: 'total_retraso',
    label: 'Minimizar Retraso',
    description: 'Minimiza el retraso total acumulado de todos los pedidos',
  },
  {
    name: 'coste',
    label: 'Minimizar Coste',
    description: 'Minimiza el coste total de producción',
  },
  {
    name: 'num_articulos_con_retraso',
    label: 'Min. Artículos con Retraso',
    description: 'Minimiza el número de artículos que se entregan con retraso',
  },
  {
    name: 'makespan',
    label: 'Minimizar Makespan',
    description: 'Minimiza el tiempo total de finalización de todos los pedidos',
  },
  {
    name: 'minimize_transitions',
    label: 'Minimizar Transiciones',
    description: 'Minimiza los cambios entre actividades en las máquinas',
  },
]

export const crearCriterioHibrido = () => ({
  type: 'hybrid',
  objectives: OBJETIVOS_OPTIMIZACION.map((obj) => ({
    name: obj.name,
    weight: obj.name === 'total_retraso' ? 1 : 0,
  })),
})

export const esCriterioHibrido = (criterio) =>
  typeof criterio === 'object' && criterio?.type === 'hybrid'
